import FeatureGates from '@atlaskit/feature-gate-js-client';

import { Cohorts } from '../../constants/cohorts';

export const getFreeToUpgradeEditionAwarenessCohort = () => {
	return FeatureGates.getExperimentValue(
		'confluence_free_to_upgrade_edition_awareness',
		'cohort',
		Cohorts.NOT_ENROLLED,
		{ fireExperimentExposure: false },
	);
};

export const getTrialStandardDifferentiatorsCohort = () => {
	return FeatureGates.getExperimentValue(
		'confluence_standard_differentiators',
		'cohort',
		Cohorts.NOT_ENROLLED,
		{ fireExperimentExposure: false },
	);
};

export const manuallyLogFreeToUpgradeEditionAwarenessExposure = () =>
	FeatureGates.manuallyLogExperimentExposure('confluence_free_to_upgrade_edition_awareness');

export const manuallyLogTrialStandardDifferentiatorsExposure = () =>
	FeatureGates.manuallyLogExperimentExposure('confluence_standard_differentiators');

export const isFreeToUpgradeEditionAwarenessEnrolled = () =>
	getFreeToUpgradeEditionAwarenessCohort() !== Cohorts.NOT_ENROLLED;

export const isFreeToUpgradeEditionAwarenessVariation = () =>
	getFreeToUpgradeEditionAwarenessCohort() === Cohorts.EXPERIMENT;

export const isTrialStandardDifferentiatorsVariation = () =>
	getTrialStandardDifferentiatorsCohort() === Cohorts.EXPERIMENT;

export const isTrialStandardDifferentiatorsEnrolled = () =>
	getTrialStandardDifferentiatorsCohort() !== Cohorts.NOT_ENROLLED;
